import { useEffect } from 'react';

/**
 * While `active` is true and the component is mounted, ensure the
 * <html> element has the `mobile-nav-hidden` class so the fixed
 * mobile bottom nav is hidden behind a full-screen modal/wizard/sheet.
 *
 * Mirrors the pattern established in ParsWizardModal.jsx:
 *   - Only adds the class if it isn't already present (so onboarding /
 *     other pages that suppress the nav independently keep working).
 *   - Cleanup only removes the class we added ourselves.
 *   - Also sends `modal_backdrop_show` / `modal_backdrop_hide` messages
 *     to the React Native WebView wrapper so the native shell can adjust
 *     its own chrome (status bar / safe-area) accordingly.
 *
 * Pass a falsy `active` to disable the effect (e.g. when the host
 * component is rendered but currently hidden via a `visible` / `isOpen`
 * prop and bails out before its overlay markup).
 */
export default function useHideMobileNav(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    let addedNavHidden = false;
    if (
      typeof document !== 'undefined'
      && !document.documentElement.classList.contains('mobile-nav-hidden')
    ) {
      document.documentElement.classList.add('mobile-nav-hidden');
      addedNavHidden = true;
    }
    try {
      if (typeof window !== 'undefined' && window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: 'modal_backdrop_show' })
        );
      }
    } catch (_) {}
    return () => {
      if (addedNavHidden && typeof document !== 'undefined') {
        document.documentElement.classList.remove('mobile-nav-hidden');
      }
      try {
        if (typeof window !== 'undefined' && window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({ type: 'modal_backdrop_hide' })
          );
        }
      } catch (_) {}
    };
  }, [active]);
}
